import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  private formSubmittedSource = new Subject<void>();

  formSubmitted$ = this.formSubmittedSource.asObservable();

  triggerFormSubmitted() {
    this.formSubmittedSource.next();
  }
}
